<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableMailboxWarningDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['nonCloudResources:mailbox:log']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          v-hasPermission="['nonCloudResources:mailbox:edit_alert_rule']"
          @click="addOrUpdateHandle(row.id)"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['nonCloudResources:mailbox:delete_alert_rule']"
            @click="mailboxWarningModal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除报警规则模式框 -->
    <Modal v-model="mailboxWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeMailboxWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-mailbox-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-mailbox-warning>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../../common/AlertRuleOperationLog.vue";
import AddOrUpdateMailboxWarning from "./AddOrUpdateMailboxWarning";

var tableMailboxWarningVue = {};
export default {
  name: "TableMailboxWarning",
  components: {
    AddOrUpdateMailboxWarning,
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      monitorModule: 34,
      mailboxWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      stateType: ["enabled", "disabled"],
      columns: [
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "enabled" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName"
        },
        {
          title: this.$t("alarms.common.alertRule"),
          key: "alertRuleDesc"
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList"
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName"
        },
        {
          title: this.$t("common.operation"),
          width: 200,
          slot: "delete"
        }
      ],
      tableMailboxWarningDate: []
    };
  },
  beforeCreate: function() {
    tableMailboxWarningVue = this;
  },
  mounted: function() {
    tableMailboxWarningVue.getMailboxWarningData();
  },
  methods: {
    showAll: function() {
      tableMailboxWarningVue.getMailboxWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getMailboxWarningData: function() {
      eventBus.$on("alertRuleSearchName", function(val) {
        tableMailboxWarningVue.alertRuleSearchName = val;
      });
      eventBus.$on("companyId", function(val) {
        tableMailboxWarningVue.companyId = val;
      });
      //报警规则列表分页
      this.$api.alertRule
        .pageAlertRule({
          companyId: tableMailboxWarningVue.companyId,
          alertRuleName: tableMailboxWarningVue.alertRuleSearchName,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: this.monitorModule
        })
        .then(res => {
          this.tableMailboxWarningDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;

          for (var i = 0; i < this.tableMailboxWarningDate.length; i++) {
            // 状态
            this.tableMailboxWarningDate[i].state = this.stateType[
              this.tableMailboxWarningDate[i].state
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableMailboxWarningVue.getMailboxWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableMailboxWarningVue.getMailboxWarningData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (this.tableMailboxWarningDate[index].state == "enabled") {
        this.changeStatusMessage(
          this.tableMailboxWarningDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableMailboxWarningDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableMailboxWarningVue.getMailboxWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableMailboxWarningDate[index].alertRuleName;
    },
    removeMailboxWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //报警规则删除
      this.$api.alertRule
        .deleteAlertRule("id", this.tableMailboxWarningDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableMailboxWarningVue.getMailboxWarningData();
            this.isDisable = false;
            this.modal_loading = false;
            this.mailboxWarningModal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/mailbox/TableMailboxWarning.vue